<template>
	<v-container width="100%" ml-auto mr-auto pl-3 pr-0 pb-3 style="padding-top: 150px;">
		<v-flex mb-4>
			<v-btn to="/SearchType1">Вернуться к фильтрам</v-btn>
		</v-flex>

		<v-layout>
			<v-flex xs12 sm6>
				<v-card p-3>
					<v-card-title>
						<div> 
								Vlad Boreyko, [20.06.19 14:48]
								копия

								РЕШЕНИЕ
								ИМЕНЕМ РЕСПУБЛИКИ КАЗАХСТАН

								30 октября 2018 года            Дело № 7527-18-00-2/23308                 г. Алматы

								Специализированный межрайонный экономический суд г. Алматы под председательством судьи Салимбаевой К.Н., рассмотрев в порядке упрощенного производства гражданское дело по иску:

								ИСТЕЦ:
								ТОО «КаР-Тел»

								ОТВЕТЧИК:
								АОЗТ «Дена Рахсаз Констракшн» 

								ТРЕБОВАНИЯ ИСТЦА:
								взыскать с ответчика задолженность в размере 49 399 тенге.

								ОПИСАТЕЛЬНАЯ ЧАСТЬ:

								В обоснование заявленных исковых требований истец ссылается на неисполнение ответчиком принятых по договору на обслуживание корпоративного клиента № AST 7981 от 19 февраля 2015 года обязательств по оплате предоставленных истцом услуг сети сотовой связи, в связи с чем образовалась задолженность в указанном размере. 
								В установленный судом срок возражений на исковое заявление со стороны АОЗТ «Дена Рахсаз Констракшн» не поступило. 

								МОТИВИРОВОЧНАЯ ЧАСТЬ:

								Исследовав материалы дела, суд приходит к следующему выводу. 
								Непредставление ответчиком АОЗТ «Дена Рахсаз Констракшн» возражений на исковое заявление суд расценивает как нежелание ответчика представить доказательства в обоснование своих доводов по несогласию с иском, в связи с чем доводы истца о неисполнении ответчиком обязательств по оплате предоставленных услуг суд признает доказанными по следующим основаниям.
								Из материалов дела следует, что по условиям договора на обслуживание корпоративного клиента № AST 7981 от 19 февраля 2015 года ТОО «КаР-Тел» предоставляет на условиях настоящего договора клиенту, а клиент АОЗТ «Дена Рахсаз Констракшн» принимает и оплачивает услуги сотовой связи стандарта GSM сети «КаР-Тел» на территории Республики Казахстан для корпоративной группы, определенной клиентом (приложение № 1 к договору), согласно корпоративного(-ым) тарифного(-ым) плана(-ам) (приложение № 2 к договору), на условиях, предусмотренных настоящим договором.
								В силу пункта 3.1.3 договора клиент обязуется оплачивать услуги по настоящему договору в соответствии с разделом 4 договора.
								Так, пунктом 4.1 договора определено, что оплата за услуги, оказанные в рамках договора, будет осуществляться клиентом на основании счета-фактуры ежемесячно до 30 числа месяца, следующего за учетным. Обязательства по оплате за услуги считаются выполненными с момента поступления оплаты на счет ТОО «КаР-Тел», за исключением случаев, предусмотренных договором и/или приложениями к нему.
								В соответствии со статьей 272 ГК обязательство должно исполняться надлежащим образом в соответствии с условиями обязательства и требованиями законодательства, а при отсутствии таких условий и требований – в соответствии с обычаями делового оборота или иными обычно предъявляемыми требованиями. 
								В соответствии с пунктом 1 статьи 349 ГК под нарушением обязательства понимается его неисполнение либо исполнение ненадлежащим образом. 
								Однако со стороны клиента АОЗТ «Дена  Рахсаз Констракшн» обязательства по договору в части своевременной и полной оплаты предоставленных услуг сотовой связи не выполнены надлежащим образом, в результате чего образовалась задолженность в размере 49 399 тенге, наличие которой объективно подтверждается материалами дела, в частности, договором, счетами на оплату и письмом-уведомлением. 
								При таких обстоятельствах, изучив доказательства, представленные истцом в обоснование своего иска, суд считает необходимым удовлетворить исковые требования ТОО «КаР-Тел» к АОЗТ «Дена Рахсаз Констракшн» о взыскании задолженности. 
								В соответствии со статьей 109 ГПК стороне, в пользу которой состоялось решение, суд присуждает с другой стороны все понесенные по делу судебные расходы. 
								В связи с изложенным суд считает подлежащими взысканию с ответчика в пользу истца расходы по оплате государственной пошлины в размере 1 482 тенге, расходы по оплате комиссии банка за оплату государственной пошлины в размере 100 тенге.

								РЕЗОЛЮТИВНАЯ ЧАСТЬ:

								Руководствуясь статьями 223-226, 229 ГПК, суд

								РЕШИЛ:

								Vlad Boreyko, [20.06.19 14:48]
								Удовлетворить исковые требования ТОО «КаР-Тел» к АОЗТ «Дена Рахсаз Констракшн» о взыскании задолженности. 
								Взыскать с АОЗТ «Дена Рахсаз Констракшн» в пользу ТОО «КаР-Тел» задолженность в размере 49 399 (сорок девять тысяч триста девяносто девять) тенге, расходы по оплате государственной пошлины в размере 1 482 (одна тысяча четыреста восемьдесят два) тенге и расходы по оплате комиссии банка за оплату государственной пошлины в размере 100 (сто) тенге.
								Ответчик вправе подать в суд, вынесший решение в порядке упрощенного (письменного) производства, заявление об отмене этого решения в течение пяти рабочих дней со дня получения копии решения суда. 
								На решение может быть подана апелляционная жалоба или ходатайство прокурора в апелляционную судебную коллегию по гражданским делам Алматинского городского суда через специализированный межрайонный экономический суд г. Алматы по истечении срока на подачу заявления об отмене этого решения, а в случае, если заявление подано, – в месячный срок после вынесения судом определения об отказе в удовлетворении этого заявления.


								Судья              Салимбаева К.Н.


								Справка.
								Решение суда на 30 октября 2018 года не вступило в законную силу.
								Судья                                                                       Салимбаева К.Н.
						</div>
					</v-card-title>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import axios from 'axios';

export default {
	name: 'DocumentCard',

	data: function () {
		return {
		}
	},

  	computed: {
	},

	methods: {
	}
}
</script>

<style lang="scss">
</style>
